/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createContext } from "react";

const DocumentEditContext = createContext(null);

export { DocumentEditContext };
